"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ts_lib_crypto_1 = require("@waves/ts-lib-crypto");
function wavesAddress2eth(wavesAddress) {
    var rawBytes = ts_lib_crypto_1.base58Decode(wavesAddress);
    var bytes = rawBytes.slice(2, rawBytes.byteLength - 4);
    return "0x" + ts_lib_crypto_1.base16Encode(bytes);
}
exports.default = wavesAddress2eth;
